"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MultiFileUploader = MultiFileUploader;
/** @jsx jsx */
var core_1 = require("@emotion/core");
var react_1 = __importStar(require("react"));
var file_validator_1 = require("@cd2/file-validator");
var FileboyProvider_1 = require("../FileboyProvider");
var _Parts_1 = require("./_Parts");
var utils_1 = require("../utils");
var useTimeout_1 = require("../useTimeout");
function MultiFileUploader(props) {
    var _a, _b;
    var uploaderStyle = props.uploaderStyle;
    var initialKeyRef = (0, react_1.useRef)(Math.random() + "");
    if (props.render && uploaderStyle) {
        (0, utils_1.warning)("FileUploader does not support both a render prop and uploaderStyle.");
    }
    if (!props.render && uploaderStyle === undefined) {
        uploaderStyle = "default";
    }
    var builtInRenderers = {
        minimal: MinimalRenderer,
        default: DefaultRenderer,
        buttonOnly: ButtonOnlyRenderer,
    };
    if (uploaderStyle && !(uploaderStyle in builtInRenderers)) {
        var builtInNames = Object.keys(builtInRenderers);
        (0, utils_1.warning)("unknown uploaderStyle \"".concat(uploaderStyle, "\" expected one of ").concat(builtInNames.join(",")));
        uploaderStyle = "default";
    }
    var setTimeout = (0, useTimeout_1.useTimeout)();
    var _c = (0, react_1.useState)(), error = _c[0], setError = _c[1];
    var _d = (0, react_1.useState)((_a = props.defaultFileIds) !== null && _a !== void 0 ? _a : []), fileIds = _d[0], setFileIds = _d[1];
    var _e = (0, react_1.useState)(false), isUploading = _e[0], setIsUploading = _e[1];
    var _f = (0, react_1.useState)(false), visualUploadDelay = _f[0], setVisualUploadDelay = _f[1];
    var fileboy = (0, FileboyProvider_1.useFileboy)(props.namespace);
    var fileInputRef = (0, react_1.useRef)(null);
    var DropZone = (0, react_1.useMemo)(function () {
        return function (_a) {
            var children = _a.children, dropZoneProps = __rest(_a, ["children"]);
            return ((0, core_1.jsx)(_Parts_1.FileUploadContainer, __assign({ onDropFile: function (files) { return uploadFiles(Array.from(files)); } }, dropZoneProps), children));
        };
    }, []);
    function handleFileChange(e) {
        if (!e.target.files) {
            return;
        }
        uploadFiles(Array.from(e.target.files));
    }
    function uploadFiles(files) {
        return __awaiter(this, void 0, void 0, function () {
            var uploadAllFiles, data_1, e_1;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (props.allow) {
                            if (files.some(function (file) { return !(0, file_validator_1.isFileAllowed)(file, props.allow); })) {
                                setError("Disallowed file given");
                                return [2 /*return*/];
                            }
                        }
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, 4, 5]);
                        setIsUploading(true);
                        setVisualUploadDelay(true);
                        setTimeout(function () { return setVisualUploadDelay(false); }, props.uploaderStyle === "buttonOnly" ? 1000 : 250);
                        if (props.onStartUpload) {
                            props.onStartUpload();
                        }
                        uploadAllFiles = function () { return __awaiter(_this, void 0, void 0, function () {
                            return __generator(this, function (_a) {
                                return [2 /*return*/, Promise.all(files.map(function (file, i) {
                                        var fileData = __assign(__assign({}, (0, utils_1.extractFileDataFromFile)(file)), { index: i });
                                        var name = props.fileName ? props.fileName(fileData) : file.name;
                                        var metadata = props.metadata ? props.metadata(fileData) : undefined;
                                        return fileboy.uploadFile(file, { name: name, metadata: metadata });
                                    }))];
                            });
                        }); };
                        return [4 /*yield*/, uploadAllFiles()];
                    case 2:
                        data_1 = _a.sent();
                        if (props.onFilesUploaded) {
                            props.onFilesUploaded(data_1);
                        }
                        setFileIds(function (ids) { return __spreadArray(__spreadArray([], (ids !== null && ids !== void 0 ? ids : []), true), data_1.map(function (el) { return el.id; }), true); });
                        return [3 /*break*/, 5];
                    case 3:
                        e_1 = _a.sent();
                        console.error(e_1);
                        setError(e_1.message);
                        return [3 /*break*/, 5];
                    case 4:
                        if (props.onUploadEnd) {
                            props.onUploadEnd();
                        }
                        setIsUploading(false);
                        return [7 /*endfinally*/];
                    case 5: return [2 /*return*/];
                }
            });
        });
    }
    function openFileDialogue() {
        if (fileInputRef.current) {
            fileInputRef.current.click();
        }
    }
    function handleRemoveFile(id) {
        if (props.onFileRemove) {
            var filteredFileIds = fileIds.filter(function (el) { return el !== id; });
            props.onFileRemove(id);
            setFileIds(filteredFileIds);
        }
    }
    var Render = props.render || builtInRenderers[uploaderStyle !== null && uploaderStyle !== void 0 ? uploaderStyle : "default"];
    return ((0, core_1.jsx)(react_1.default.Fragment, null,
        (0, core_1.jsx)("input", { ref: fileInputRef, key: (_b = fileIds.join()) !== null && _b !== void 0 ? _b : initialKeyRef.current, type: "file", onChange: handleFileChange, accept: props.allow && Array.isArray(props.allow) ? props.allow.join(",") : props.allow, multiple: true, hidden: true }),
        (0, core_1.jsx)(Render, { error: error, ids: fileIds, openFileDialogue: openFileDialogue, uploadFilesManually: uploadFiles, isUploading: isUploading || visualUploadDelay, DropZone: DropZone, theme: props.theme, onRemoveFile: props.onFileRemove ? handleRemoveFile : undefined })));
}
function MinimalRenderer(_a) {
    var _b, _c;
    var error = _a.error, ids = _a.ids, openFileDialogue = _a.openFileDialogue, DropZone = _a.DropZone, isUploading = _a.isUploading, theme = _a.theme, onRemoveFile = _a.onRemoveFile;
    return ((0, core_1.jsx)(DropZone, { inlineBlock: true },
        (0, core_1.jsx)("div", { css: (0, core_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n          display: flex;\n          font-family: ", ";\n          align-items: center;\n          > * {\n            margin-right: 8px;\n          }\n        "], ["\n          display: flex;\n          font-family: ", ";\n          align-items: center;\n          > * {\n            margin-right: 8px;\n          }\n        "])), theme === null || theme === void 0 ? void 0 : theme.fontFamily) },
            (0, core_1.jsx)("div", null,
                (0, core_1.jsx)(_Parts_1.ErrorString, { string: error }),
                ids && ids.length ? ((0, core_1.jsx)("div", { className: "fileboy-preview", css: (0, core_1.css)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n                padding: 8px 0;\n              "], ["\n                padding: 8px 0;\n              "]))) }, ids.map(function (id) { return ((0, core_1.jsx)("div", { key: id },
                    (0, core_1.jsx)(_Parts_1.PreviewFileName, { id: id, onRemoveFile: onRemoveFile ? function () { return onRemoveFile(id); } : undefined }))); }))) : (""),
                (0, core_1.jsx)(_Parts_1.UploadButton, { buttonColor: (_b = theme === null || theme === void 0 ? void 0 : theme.colors) === null || _b === void 0 ? void 0 : _b.button, buttonTextColor: (_c = theme === null || theme === void 0 ? void 0 : theme.colors) === null || _c === void 0 ? void 0 : _c.buttonText, onClick: openFileDialogue, value: isUploading ? "Uploading..." : ids && ids.length > 0 ? "Add Files" : "Upload Files", disabled: isUploading })))));
}
function ButtonOnlyRenderer(_a) {
    var _b, _c;
    var error = _a.error, openFileDialogue = _a.openFileDialogue, DropZone = _a.DropZone, isUploading = _a.isUploading, theme = _a.theme;
    return ((0, core_1.jsx)("div", { css: (0, core_1.css)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n        font-family: ", ";\n        display: inline-block;\n      "], ["\n        font-family: ", ";\n        display: inline-block;\n      "])), theme === null || theme === void 0 ? void 0 : theme.fontFamily) },
        (0, core_1.jsx)(DropZone, { inlineBlock: true },
            (0, core_1.jsx)(_Parts_1.ErrorString, { string: error }),
            (0, core_1.jsx)(_Parts_1.UploadButton, { buttonColor: (_b = theme === null || theme === void 0 ? void 0 : theme.colors) === null || _b === void 0 ? void 0 : _b.button, buttonTextColor: (_c = theme === null || theme === void 0 ? void 0 : theme.colors) === null || _c === void 0 ? void 0 : _c.buttonText, onClick: openFileDialogue, value: isUploading ? "Uploading..." : "Upload Files", disabled: isUploading }))));
}
function DefaultRenderer(_a) {
    var _b, _c;
    var error = _a.error, ids = _a.ids, openFileDialogue = _a.openFileDialogue, DropZone = _a.DropZone, isUploading = _a.isUploading, theme = _a.theme, onRemoveFile = _a.onRemoveFile;
    return ((0, core_1.jsx)("div", null,
        (0, core_1.jsx)(DropZone, { inlineBlock: true },
            (0, core_1.jsx)(_Parts_1.DefaultRenderContainer, { fontFamily: theme === null || theme === void 0 ? void 0 : theme.fontFamily },
                error,
                ids && ids.length > 0 ? ((0, core_1.jsx)("div", { className: "fileboy-preview", css: (0, core_1.css)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n                .fileboy-preview-item-container {\n                  margin: 0 4px;\n                }\n              "], ["\n                .fileboy-preview-item-container {\n                  margin: 0 4px;\n                }\n              "]))) }, ids.map(function (id) { return ((0, core_1.jsx)(_Parts_1.PreviewThumb, { key: id, id: id, onRemoveFile: onRemoveFile ? function () { return onRemoveFile(id); } : undefined })); }))) : ((0, core_1.jsx)(_Parts_1.FileUploadPrompt, { multi: true })),
                (0, core_1.jsx)("div", { css: (0, core_1.css)("margin-top: 8px") }),
                isUploading ? ((0, core_1.jsx)(_Parts_1.SVGLoadingSpinner, null)) : ((0, core_1.jsx)("div", { css: (0, core_1.css)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n                text-align: left;\n              "], ["\n                text-align: left;\n              "]))) },
                    (0, core_1.jsx)(_Parts_1.UploadButton, { buttonColor: (_b = theme === null || theme === void 0 ? void 0 : theme.colors) === null || _b === void 0 ? void 0 : _b.button, buttonTextColor: (_c = theme === null || theme === void 0 ? void 0 : theme.colors) === null || _c === void 0 ? void 0 : _c.buttonText, onClick: openFileDialogue, value: ids && ids.length > 0 ? "Add Files" : "Upload Files" })))))));
}
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5;
